import * as React from "react";
import { useHistory } from "react-router-dom";
import { SpreetailHeader } from "../layout/SpreetailHeader";

const NoDataSelected: React.FC = () => {
  const history = useHistory();

  const handleOkay = () => {
    history.push("/");
  };

  return (
    <>
      <style>
        {`
          .bg-gradient-custom {
            background: linear-gradient(180deg, #D3E8D9 0%, #EEEEEE 79.45%);
          }
        `}
      </style>
      <div className="h-screen flex flex-col relative font-sans text-gray-800 bg-gradient-custom" style={{ overflow: 'hidden' }}>
        <div className="absolute -right-10 -top-10 w-50 h-50 blur-[40px] pointer-events-none" 
             style={{ background: 'radial-gradient(circle at center, rgba(134, 239, 172, 0.3), transparent 70%)' }}></div>
        <div className="absolute -left-8 -bottom-8 w-38 h-38 blur-[40px] pointer-events-none" 
             style={{ background: 'radial-gradient(circle at center, rgba(167, 243, 208, 0.3), transparent 70%)' }}></div>
        <SpreetailHeader />

        {/* Main content area - perfectly centered */}
        <div className="flex-1 flex flex-col items-center justify-center px-5">
          <div className="flex flex-col items-center justify-center w-full" style={{ maxWidth: '420px' }}>
            {/* Search File icon - smaller */}
            <div style={{ marginBottom: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img 
                src="/assets/Search File.png" 
                alt="Search File" 
                style={{ 
                  width: '80px',
                  height: '80px',
                  objectFit: 'contain',
                  opacity: 1,
                  transform: 'translateX(-8px)'
                }}
              />
            </div>

            {/* Error message */}
            <div className="text-center" style={{ marginBottom: '48px' }}>
              <h2 
                style={{ 
                  fontSize: '18px',
                  fontWeight: 600,
                  lineHeight: '1.4',
                  color: '#1F2937',
                  marginBottom: '10px',
                  fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: '-0.01em',
                  marginTop: 0
                }}
              >
                Oops You haven't selected any data
              </h2>
              <p 
                style={{ 
                  fontSize: '13px',
                  fontWeight: 400,
                  lineHeight: '1.5',
                  color: '#6B7280',
                  fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  margin: 0,
                  padding: 0
                }}
              >
                Select some data and process to<br />generate the results
              </p>
            </div>

            {/* Okay button */}
            <button
              onClick={handleOkay}
              className="w-full text-white border-none rounded-md p-3 px-4 text-[13px] font-semibold transition-all duration-200 shadow-md flex items-center justify-center"
              style={{
                backgroundColor: '#068E75',
                boxShadow: '0 2px 4px rgba(6, 142, 117, 0.3)',
                cursor: 'pointer',
                maxWidth: '380px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#057A63';
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(6, 142, 117, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#068E75';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(6, 142, 117, 0.3)';
              }}
            >
              Okay
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NoDataSelected;